import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center flex flex-col items-center" }
const _hoisted_2 = { class: "my-8 md:my-16" }
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-2 gap-6 my-16 justify-items-center w-full sm:w-4/5"
}
const _hoisted_4 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-2 gap-6 my-16 justify-items-center w-full sm:w-4/5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_switch = _resolveComponent("toggle-switch")!
  const _component_addon_card = _resolveComponent("addon-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("Impregnacije")), 1),
    _createVNode(_component_toggle_switch, {
      labels: _ctx.title,
      switched: _ctx.switched,
      isChecked: _ctx.isChecked
    }, null, 8, ["labels", "switched", "isChecked"]),
    (_ctx.isChecked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brezbarvniVidez, (item) => {
            return (_openBlock(), _createBlock(_component_addon_card, {
              key: item,
              itemData: item,
              impregnation: true
            }, null, 8, ["itemData"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mokriVidez, (item) => {
            return (_openBlock(), _createBlock(_component_addon_card, {
              key: item,
              itemData: item,
              impregnation: true
            }, null, 8, ["itemData"]))
          }), 128))
        ]))
  ]))
}